import React from 'react';
import { Text } from 'react-native-elements';
import { StyleSheet } from 'react-native';

import { type LanguageText } from '../types/Language';
import { useLanguage } from '../context/LanguageContext';

const styles = StyleSheet.create({
    horizontalText: {
        textAlign: 'left',
        fontSize: 16,
        marginVertical: 10,
        width: '100%',
        flexWrap: 'wrap',
        maxWidth: '100%',
        overflow: 'hidden',
        wordBreak: 'break-word',
    },
    limitedText: {
        textAlign: 'left',
        fontSize: 16,
        marginVertical: 10,
        width: '100%',
        maxWidth: '100%',
        flexWrap: 'wrap',
        overflow: 'hidden',
    },
});

interface TextProps {
    data: string | number | LanguageText;
    numberOfLines?: number;
}

const TextField: React.FC<TextProps> = ({ data, numberOfLines }) => {
    const { currentLanguage } = useLanguage();

    return (
        <Text
            style={numberOfLines ? styles.limitedText : styles.horizontalText}
            numberOfLines={numberOfLines}
        >
            {typeof data === 'string' || typeof data === 'number'
                ? data
                : data[currentLanguage]}
        </Text>
    );
};

export default TextField;
